// extracted by mini-css-extract-plugin
export default {"container":"eda-z","heading":"fda-z","links":"gda-z","linkBtn":"hda-z","disabled":"ida-z","linkUppercaseBold":"jda-z","copy":"kda-z","subCopy":"lda-z"};